import { render } from "./ProfileEdit.vue?vue&type=template&id=2fe14456&scoped=true"
import script from "./ProfileEdit.vue?vue&type=script&lang=js"
export * from "./ProfileEdit.vue?vue&type=script&lang=js"

import "./ProfileEdit.vue?vue&type=style&index=0&id=2fe14456&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2fe14456"

export default script